import "client-only"
/**
 * Checks if a DOMRect is within the visual viewport
 * on both vertical and horizontal axes.
 */
export function isElementInViewport(rect: DOMRect) {
  const isVerticallyVisible = rect.top < window.innerHeight && rect.bottom > 0
  const isHorizontallyVisible = rect.left < window.innerWidth && rect.right > 0

  return isVerticallyVisible && isHorizontallyVisible
}
